exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\n.ImageSelect {\n    float: left;\n     width: calc(50% - 24px);\n    margin: 12px;\n    cursor: pointer;\n    box-sizing: border-box;\n}\n*/\n\n\n.ImageSelect-image-container {\n    position: relative;\n    /* height: 120px; */\n    /* width: 100%; */\n    margin-top: 4px;\n    overflow: hidden;\n}\n\n\n.ImageSelect-image {\n    width: 100%;\n    display: block;\n}\n\n/*\n.ImageSelect-image {\n    position: absolute;\n    clip: rect(64px, 256px, 192px, 0);\n    width: 100%;\n    top: -64px;\n}\n*/\n\n.ImageSelect-no-image {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    background: #eee;\n    color: #ccc;\n    font-size: 12px;\n    text-align: center;\n    line-height: 56px;\n}\n\n.ImageSelect-title {\n    font-size: 12px;\n    color: #333;\n    padding-top: 6px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/d2-ui/ImageSelect.css
// module id = 1131
// module chunks = 0